/** @jsx jsx */
import { jsx, Link, Flex } from "theme-ui"
//import useSiteMetadata from "../hooks/use-site-metadata"

const Footer = () => {
  //const { siteTitle } = useSiteMetadata()

  return (
    <footer
      sx={{
        boxSizing: `border-box`,
        display: `flex`,
        justifyContent: `space-between`,
        mt: [6],
        alignItems: 'center',
        color: `secondary`,
        a: {
          variant: `links.secondary`,
        },
        flexDirection: [`column`, `column`, `row`],
        variant: `dividers.top`,
      }}
    >
      <Flex>
        &copy; {new Date().getFullYear()}&nbsp;
        <Link aria-label="Mike Lapidakis's Homepage" href="https://mike.lapidak.is">
          Mike Lapidakis
        </Link>
        &nbsp;|&nbsp;All rights reserved&nbsp;|&nbsp;
        <Link aria-label="RSS Feed" href="/rss.xml">
          RSS
        </Link>
      </Flex>
    </footer>
  )
}

export default Footer